import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, subtitle, icon, trend, trendValue, iconColor }) => {
  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border shadow-warm-sm hover:shadow-warm-md smooth-transition">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground mb-1">{title}</p>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-semibold">{value}</h3>
        </div>
        <div 
          className="w-12 h-12 md:w-14 md:h-14 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: `${iconColor}15` }}
        >
          <Icon name={icon} size={24} color={iconColor} />
        </div>
      </div>
      
      <div className="flex items-center justify-between">
        <p className="text-xs md:text-sm text-muted-foreground">{subtitle}</p>
        {trend && (
          <div className={`flex items-center gap-1 text-xs md:text-sm ${trend === 'up' ? 'text-success' : 'text-error'}`}>
            <Icon name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={16} />
            <span className="data-text">{trendValue}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricsCard;